'use client';

import React from 'react';
import { Grid2 as Grid } from '@unity/cloud-ui';

interface CardGridProps {
  cols: number;
}

const CardGrid = (props: React.PropsWithChildren<CardGridProps>) => {
  const { cols = 2 } = props;

  return (
    <Grid container spacing={2} sx={{ py: 2 }}>
      {React.Children.map(props.children, (child, index) => {
        if (!React.isValidElement(child)) {
          return null;
        }
        return (
          <Grid key={index} size={{ xs: 12, md: 12 / cols }}>
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CardGrid;
